import styles from './style.postcss';
import React from 'react';
import AppBars from 'components/AppBars';
import PropTypes from 'prop-types';

const App = (props) => <div className={styles.App_container}>
  <AppBars {...props} />
  {props.children}
</div>;

App.propTypes = {
  children: PropTypes.node,
};

export default App;



// WEBPACK FOOTER //
// ./components/App/index.jsx